export default {
  namespaced: true,
  state: {
    alertDetails: null
  },
  mutations: {
    setAlert(state, alert) {
      state.alertDetails = alert
    },

    clearAlert(state) {
      state.alertDetails = {}
    }
  },
  actions: {
    addAlert({ commit }, alert) {
      commit('clearAlert', alert)
      commit('setAlert', alert)
    },

    removeAlert({ commit }) {
      commit('clearAlert')
    }
  }
}
